import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { initAdSession } from './adUtils';
import csidBuilder from './csidBuilder';
import adConfig from '../config/adConfig.json';

const mapStateToProps = state => ({
  routeParams: state.routeParams,
  templateParams: state.templateParams,
  breakpoint: state.events.breakpoint,
  country: state.country,
  sovSeed: state.ads.sovSeed,
  mappedSportRouteParam: state.mappedSportRouteParam,
});

@connect(mapStateToProps)
export default function linkTag2Initilizer(csidParam) {
  return (DecoratedComponent) => {
    return class extends React.PureComponent {
      static propTypes = {
        dataSources: React.PropTypes.object,
        routeParams: React.PropTypes.object,
        templateParams: React.PropTypes.object,
        breakpoint: React.PropTypes.number,
        country: React.PropTypes.string,
        sovSeed: React.PropTypes.string,
        adConfig: React.PropTypes.object,
        route: React.PropTypes.object,
      };

      constructor() {
        super();
        this.displayName = `linkTag2InitializerWrapper(${DecoratedComponent.name})`;
      }

      componentDidMount() {
        if (this.props.breakpoint && !this.props.dataSources) this.initAds();
      }

      componentDidUpdate(prevProps) {
        const { breakpoint, dataSources } = this.props;

        if (breakpoint && (!prevProps.breakpoint || (_.size(dataSources) && dataSources !== prevProps.dataSources))) {
          this.initAds();
        }
      }

      initAds() {
        const { breakpoint, routeParams, mappedSportRouteParam, sovSeed, country } = this.props;

        const csid = csidBuilder({
          csidParam,
          breakpoint,
          routeParams,
          sportParam: mappedSportRouteParam,
          country,
        });

        initAdSession({
          method: 'linkTag2',
          adConfig: adConfig[country],
          csid,
          sovSeed,
        });
      }

      render() {
        return (
          <DecoratedComponent {...this.props} />
        );
      }
    };
  };
}



// WEBPACK FOOTER //
// ./src/util/linkTag2Initializer.js